/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import NameTooltip from './NameTooltip/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/Account/Chairs/Content/Appointments/Content/Appointment/Name",
  hovered
  
}) {
let appointmentBookingPatientPersonValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'patient_person',
})
let globalUserPreferencesHipaaValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'user.preferences.hipaa',
})
let aggregateData = fromAggregate.patientName(appointmentBookingPatientPersonValueData, globalUserPreferencesHipaaValueData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="bold"
 color={dtColorsNeutral900}
 textOverflow="ellipsis"
 overflowX="hidden"
 overflowY="hidden"
 whiteSpace="nowrap"
 display="block"
 data="appointment_booking.patient_person"
 data="global.user.preferences.hipaa"
 aggregate="/Data/aggregate.js patientName"
 text={aggregateData}
/>
<NameTooltip
  viewPath={`${viewPath}/NameTooltip`}
 flowNo={!hovered}
 flowContent={hovered}
/>
{children}
</React.Fragment>)
}